/**
 * 调试服务, 方便在客户端环境下输出调试信息
 */
define([], function () {
  var _log = function (msg) {
    var url = `http://localhost:3000/log?msg=${msg}`;
    $.ajax({
      url,
      method: 'GET'
    });
  };

  var log = function (msg) {
    _log(`[LOG  ] ${msg}`);
  };

  var info = function (msg) {
    _log(`[INFO ] ${msg}`);
  };

  var warn = function (msg) {
    _log(`[WARN ] ${msg}`);
  };

  var error = function (msg) {
    _log(`[ERROR] ${msg}`);
  };

  var init = function () {
    console.log = log;
    console.info = info;
    console.warn = warn;
    console.error = error;
  };

  return {
    init,
    log,
    info,
    warn,
    error
  };
});



/** WEBPACK FOOTER **
 ** ./src/scripts/service/debugService.js
 **/